import React from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/styles";

// makeStylesで動的なスタイルを設定
const useStyle = makeStyles((theme) => ({
  formControl: (props) => ({
    // marginBottom: 16,
    // minWidth: 120,
    width: props.width || "100%", // デフォルトは100%
  }),
  select: (props) => ({
    height: props.height || "auto", // props.heightが指定されていない場合は自動
    fontSize: props.fontSize || "16px", // デフォルトのフォントサイズを16pxに設定
  }),
  inputLabel: (props) => ({
    fontSize: props.fontSize || "16px", // InputLabelのフォントサイズも変更
  }),
}));

const SelectBoxForFilter = (props) => {
  const classes = useStyle(props); // propsを使ってスタイルを適用
  return (
    <FormControl className={classes.formControl}>
      <InputLabel className={classes.inputLabel}>{props.label}</InputLabel>
      <Select
        required={props.required}
        value={props.value}
        onChange={(event) => props.select(event.target.value)}
        className={classes.select} // スタイルを適用
        disabled={props.disabled}
      >
        {props.options.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectBoxForFilter;
